import React from 'react';
import SeachLibrary from '../components/Library';

const LMSSalesLibraryContainer = (props) => {
  const search = props?.match?.params?.search ?? '';
  return <SeachLibrary search={search} />;
};

export default LMSSalesLibraryContainer;
